// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  align-content: center;
  background: transparent;
  display: flex;
  flex-wrap: nowrap;
  left: 0px;
  justify-content: center;
  position: sticky;
  top: 0px;
  width: 100dvw;
  z-index: 900000;
  margin-bottom: 70px;
}
.header+.banner {
  margin-top: -70px;
}
.header:before {
  background: var(--color-primary-red);
  bottom: -4px;
  content: '';
  height: 4px;
  left: 50%;
  max-width: calc(var(--grid-max-width) - (30px * 2));
  position: absolute;
  transform: translate3d(-50%, 0px, 0px);
  width: 100%
}
.header[data-banner] .header--container {
  border-radius: 0px;
}
.header[data-banner]:before {
  display: none;
}

.header[data-banner].sticky .header--container {
  border-radius: 0px 0px 30px 30px;
}

.header[data-banner].sticky:before {
  display: block;
}

.header--container {
  background: var(--color-primary-light-yellow);
  border-radius: 0px 0px 30px 30px;
  display: flex;
  align-items: center;
  max-width: var(--grid-max-width);
  position: relative;
  padding: 14px 48px;
  width: 100%;
  z-index: -1;
}

.menu {
  margin-left: auto;
  max-width: var(--grid-max-width);
  width: fit-content;
  z-index: 1;
}
.menu ul {
  background: var(--color-primary-light-yellow);
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  margin: 0px;
  list-style: none;;
  padding: 0px;
}
.menu ul li a,
.menu ul li button {
  min-width: 67px;
  font-size: 14px;
  padding: 12px 14px;
  line-height: 1rem;
  white-space: nowrap;
}

.menu ul li a:not(.access) {
  border: 2px solid var(--color-contrast-dark-gray);
  color: var(--color-contrast-dark-gray);
}

.menu--toggle {
  align-items: center;
  border: none;
  display: none;
  height: 36px;
  justify-content: center;
  right: 24px;
  outline: none;
  position: absolute;
  top: 50%;
  transform: translate3d(0px, -50%, 0px);
  width: 36px;
}

.menu--toggle > img[alt=close] {
  display: none;
}
.menu--toggle.active > img[alt=menu] {
  display: none;
}
.menu--toggle.active > img[alt=close] {
  display: block;
}

@media (max-width: 768px) {
  .header--container {
    padding: 15px 24px;
    pointer-events: all;
  }
  .header:before {
    width: 70%;
  }

  .header[data-banner] .header--container {
    border-radius: 0px;
  }
  .header[data-banner] .header--container:after {
    display: none;
  }
  .header:not[data-banner] .header--container {
    border-radius: 0px 0px 20px 20px !important;
    flex-wrap: wrap;
  }

  .header[data-banner].sticky:before {
    display: block;
  }

  .header[data-banner].sticky .header--container:after {
    display: block;
  }

  .header[data-banner].sticky .header--container {
    border-radius: 0px 0px 20px 20px;
  }

  .header .header--container:after {
    background: var(--color-primary-red);
    border-radius: 0px 0px 50px 50px;
    content: '';
    height: 4px;
    left: 50%;
    position: absolute;
    top: 100%;
    transform: translate3d(-50%, 0px, 0px);
    width: calc(100% - (30px * 2));
  }

  /* .menu {
    display: none;
    left: 0px;
    position: absolute;
    top: 122px;
    width: 100%;
  }

  .menu > ul {
    gap: 32px;
    flex-wrap: wrap;
    padding: 0px 24px 60px;
    position: relative;
    width: 100%;
  }
  .menu > ul:after, .menu > ul:before {
    content: '';
    position: absolute;
  }
  .menu > ul:before {
    background: var(--color-primary-light-yellow);
    height: 122px;
    left: 0px;
    top: 0;
    transform: translate3d(0px, -100%, 0px);
    width: 100%;
    z-index: -1;
  }
  .menu > ul:after {
    background: var(--color-primary-red);
    border-radius: 0px 0px 50px 50px;
    height: 4px;
    left: 50%;
    top: 100%;
    transform: translate3d(-50%, 0px, 0px);
    width: calc(100% - (30px * 2));
  }
  .menu > ul > li {
    text-align: left;
    width: 100%;
  }
  .menu > ul > li > a {
    border: none;
    font-size: 20px;
    justify-content: flex-start;
    width: 100%;
  } */

  .menu--toggle {
    display: flex;
  }

  .logo > img {
    width: 236px;
  }

  .header:has(.menu--toggle.active)::before,
  .header[data-banner].sticky:has(.menu--toggle.active)::before,
  .header[data-banner].sticky .header--container:has(.menu--toggle.active)::after,
  .header--container:has(.menu--toggle.active)::after {
    content: none;
  }

  .header[data-banner].sticky .header--container:has(.menu--toggle.active),
  .header--container:has(.menu--toggle.active) {
    border-radius: 0;
  }

  .header--container:has(.menu--toggle.active) .menu {
    left: 0;
    opacity: 1;
  }

  .menu {
    width: 100%;
    height: calc(95vh - 80px);
    background-color: var(--color-primary-light-yellow);
    padding: 60px 24px;
    border-radius: 0 0 20px 20px;
    position: absolute;
    top: 98%;
    left: -100%;
    display: flex;
    flex-direction: column;
    gap: 60px;
    opacity: 0;
    transition: left ease-in 0.3s, opacity ease-in 0.3s;
  }

  .menu::after {
    content: "";
    width: 90%;
    height: 4px;
    background-color: var(--color-primary-red);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  .menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
  }

  .menu ul li {
    width: 100%;
    text-align: start;
  }

  .menu ul li a:not(.access){
    width: 100%;
    padding: 12px 0;
    margin: 0 20px;
    border: none;
    font-size: 20px;
    line-height: 24px;
    color: var(--color-contrast-dark-gray);
    justify-content: flex-start;
  }

  .menu ul li .access {
    padding: 12px 28px;
    margin: 0 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scripts/components/menu/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,SAAS;EACT,mDAAmD;EACnD,kBAAkB;EAClB,sCAAsC;EACtC;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,6CAA6C;EAC7C,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,2CAA2C;IAC3C,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,sCAAsC;IACtC,8BAA8B;EAChC;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA8CG;;EAEH;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mDAAmD;IACnD,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,mDAAmD;EACrD;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF","sourcesContent":[".header {\n  align-content: center;\n  background: transparent;\n  display: flex;\n  flex-wrap: nowrap;\n  left: 0px;\n  justify-content: center;\n  position: sticky;\n  top: 0px;\n  width: 100dvw;\n  z-index: 900000;\n  margin-bottom: 70px;\n}\n.header+.banner {\n  margin-top: -70px;\n}\n.header:before {\n  background: var(--color-primary-red);\n  bottom: -4px;\n  content: '';\n  height: 4px;\n  left: 50%;\n  max-width: calc(var(--grid-max-width) - (30px * 2));\n  position: absolute;\n  transform: translate3d(-50%, 0px, 0px);\n  width: 100%\n}\n.header[data-banner] .header--container {\n  border-radius: 0px;\n}\n.header[data-banner]:before {\n  display: none;\n}\n\n.header[data-banner].sticky .header--container {\n  border-radius: 0px 0px 30px 30px;\n}\n\n.header[data-banner].sticky:before {\n  display: block;\n}\n\n.header--container {\n  background: var(--color-primary-light-yellow);\n  border-radius: 0px 0px 30px 30px;\n  display: flex;\n  align-items: center;\n  max-width: var(--grid-max-width);\n  position: relative;\n  padding: 14px 48px;\n  width: 100%;\n  z-index: -1;\n}\n\n.menu {\n  margin-left: auto;\n  max-width: var(--grid-max-width);\n  width: fit-content;\n  z-index: 1;\n}\n.menu ul {\n  background: var(--color-primary-light-yellow);\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 12px;\n  margin: 0px;\n  list-style: none;;\n  padding: 0px;\n}\n.menu ul li a,\n.menu ul li button {\n  min-width: 67px;\n  font-size: 14px;\n  padding: 12px 14px;\n  line-height: 1rem;\n  white-space: nowrap;\n}\n\n.menu ul li a:not(.access) {\n  border: 2px solid var(--color-contrast-dark-gray);\n  color: var(--color-contrast-dark-gray);\n}\n\n.menu--toggle {\n  align-items: center;\n  border: none;\n  display: none;\n  height: 36px;\n  justify-content: center;\n  right: 24px;\n  outline: none;\n  position: absolute;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0px);\n  width: 36px;\n}\n\n.menu--toggle > img[alt=close] {\n  display: none;\n}\n.menu--toggle.active > img[alt=menu] {\n  display: none;\n}\n.menu--toggle.active > img[alt=close] {\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .header--container {\n    padding: 15px 24px;\n    pointer-events: all;\n  }\n  .header:before {\n    width: 70%;\n  }\n\n  .header[data-banner] .header--container {\n    border-radius: 0px;\n  }\n  .header[data-banner] .header--container:after {\n    display: none;\n  }\n  .header:not[data-banner] .header--container {\n    border-radius: 0px 0px 20px 20px !important;\n    flex-wrap: wrap;\n  }\n\n  .header[data-banner].sticky:before {\n    display: block;\n  }\n\n  .header[data-banner].sticky .header--container:after {\n    display: block;\n  }\n\n  .header[data-banner].sticky .header--container {\n    border-radius: 0px 0px 20px 20px;\n  }\n\n  .header .header--container:after {\n    background: var(--color-primary-red);\n    border-radius: 0px 0px 50px 50px;\n    content: '';\n    height: 4px;\n    left: 50%;\n    position: absolute;\n    top: 100%;\n    transform: translate3d(-50%, 0px, 0px);\n    width: calc(100% - (30px * 2));\n  }\n\n  /* .menu {\n    display: none;\n    left: 0px;\n    position: absolute;\n    top: 122px;\n    width: 100%;\n  }\n\n  .menu > ul {\n    gap: 32px;\n    flex-wrap: wrap;\n    padding: 0px 24px 60px;\n    position: relative;\n    width: 100%;\n  }\n  .menu > ul:after, .menu > ul:before {\n    content: '';\n    position: absolute;\n  }\n  .menu > ul:before {\n    background: var(--color-primary-light-yellow);\n    height: 122px;\n    left: 0px;\n    top: 0;\n    transform: translate3d(0px, -100%, 0px);\n    width: 100%;\n    z-index: -1;\n  }\n  .menu > ul:after {\n    background: var(--color-primary-red);\n    border-radius: 0px 0px 50px 50px;\n    height: 4px;\n    left: 50%;\n    top: 100%;\n    transform: translate3d(-50%, 0px, 0px);\n    width: calc(100% - (30px * 2));\n  }\n  .menu > ul > li {\n    text-align: left;\n    width: 100%;\n  }\n  .menu > ul > li > a {\n    border: none;\n    font-size: 20px;\n    justify-content: flex-start;\n    width: 100%;\n  } */\n\n  .menu--toggle {\n    display: flex;\n  }\n\n  .logo > img {\n    width: 236px;\n  }\n\n  .header:has(.menu--toggle.active)::before,\n  .header[data-banner].sticky:has(.menu--toggle.active)::before,\n  .header[data-banner].sticky .header--container:has(.menu--toggle.active)::after,\n  .header--container:has(.menu--toggle.active)::after {\n    content: none;\n  }\n\n  .header[data-banner].sticky .header--container:has(.menu--toggle.active),\n  .header--container:has(.menu--toggle.active) {\n    border-radius: 0;\n  }\n\n  .header--container:has(.menu--toggle.active) .menu {\n    left: 0;\n    opacity: 1;\n  }\n\n  .menu {\n    width: 100%;\n    height: calc(95vh - 80px);\n    background-color: var(--color-primary-light-yellow);\n    padding: 60px 24px;\n    border-radius: 0 0 20px 20px;\n    position: absolute;\n    top: 98%;\n    left: -100%;\n    display: flex;\n    flex-direction: column;\n    gap: 60px;\n    opacity: 0;\n    transition: left ease-in 0.3s, opacity ease-in 0.3s;\n  }\n\n  .menu::after {\n    content: \"\";\n    width: 90%;\n    height: 4px;\n    background-color: var(--color-primary-red);\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 32px;\n  }\n\n  .menu ul li {\n    width: 100%;\n    text-align: start;\n  }\n\n  .menu ul li a:not(.access){\n    width: 100%;\n    padding: 12px 0;\n    margin: 0 20px;\n    border: none;\n    font-size: 20px;\n    line-height: 24px;\n    color: var(--color-contrast-dark-gray);\n    justify-content: flex-start;\n  }\n\n  .menu ul li .access {\n    padding: 12px 28px;\n    margin: 0 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
